import styled, { css } from "styled-components";

export const Container = styled.button`
  outline: none;
  border: none;
  border-radius: 0;
  /* min-width: 100%; */
  font-weight: 700;
  font-size: 12px;
  color: #999999;
  background-color: #eaeaea;
  min-height: 28px;
  letter-spacing: 2px;
  text-transform: uppercase;
  padding: 0.5em 1em;
  cursor: pointer;
  font-family: "Roboto Condensed", sans-serif;
  border-radius: 5px;

  ${(props) =>
    props.primary &&
    css`
      background-color: #8b0304;
      color: #fff;
    `}

  ${(props) =>
    props.secondary &&
    css`
      background-color: #333;
      color: #fff;
    `}

  &:disabled {
    background-color: rgba(51, 51, 51, 0.2);
    cursor: not-allowed;
  }

  &:active {
    filter: brightness(1.2);
    transition: all 0.2s ease-in-out;
  }

  &:hover {
    filter: brightness(0.9);
    transition: all 0.2s ease-in-out;
  }

  &:disabled:hover {
    filter: brightness(1);
  }

  ${(props) =>
    props.loading &&
    css`
      cursor: default;
    `}
`;
